module.exports = __webpack_public_path__ + "static/img/out.f54f1311.png";